import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import queryString from 'query-string';
import { createBrowserHistory } from 'history';

import { CRS_URL, GET_CRS_DATA } from './commons/apiConfig';
import { initializeTranslationStorage } from './commons/localize';
import { getRedirectData, initializeSecurity } from './commons/apiCalls';

import { getReducers, getStore } from './reducers';
import ReservationsTTOO from './reservationsTTOO';
import * as serviceWorker from './serviceWorker';

import './index.css';
import './commons/icons/icons.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const history = createBrowserHistory();

const initializeApp = async () => {
  const params = queryString.parse(window.location.search);
  const redirectData = await getRedirectData(params);
  history.replace();

  if (redirectData.invalidToken) {
    window.location = CRS_URL;
    return;
  }

  const { pathname } = window.location;
  const store = getStore(getReducers(pathname));

  await initializeSecurity(redirectData, store);
  const crsData = GET_CRS_DATA();
  await initializeTranslationStorage(crsData.language).then(() => {
    ReactDOM.render(
      <Provider store={store}>
        <ReservationsTTOO />
      </Provider>
      ,
      document.getElementById('root')
    );
  });
};

initializeApp();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
